import React from "react";
import { Image } from "@wss/image";
import { cls } from "cls";
interface Props {
  id: number;
  name: string;
  image: string;
  link: string;
}
const FeaturedCategoryItem = ({
  id,
  name,
  image,
  link
}: Props) => <li key={id} className={cls("text-center", "mb-8", "group", "lt:mb-4")} data-testid="featured-categories" data-sentry-component="FeaturedCategoryItem" data-sentry-source-file="FeaturedCategoryItem.tsx">
    <a data-testid="featured-category-link" href={link} className={cls("flex", "flex-col", "justify-center", "items-center", "group")}>
      {!image ? <div style={{
      width: "8.75rem",
      height: "8.75rem"
    }} className={cls("bg-gray-50", "gap-4", "rounded-full", "my-0", "mx-auto", "group-hover:opacity-75")} /> : <Image src={image} alt="" loading="lazy" width={1} height={1} className="w-32 h-32 xxxs:h-auto bg-gray-50 rounded-full border border-solid border-transparent group-hover:opacity-75" data-testid="featured-category-image" />}
      <p className={cls("text-sm", "leading-none", "text-gray-900", "group-hover:text-green-500", "group-hover:underline", "mb-0", "p-1", "transition-all", "duration-75", "ease-in-out", "mt-2", "lt:mt-5")}>
        {name}
      </p>
    </a>
  </li>;
export default FeaturedCategoryItem;